import React, { useContext, useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import UserInvoices from '../Tabs/UserInvoices'
import LoginInfo from '../Tabs/LoginInfo'
import Credits from '../Tabs/Credits'
import UserEmailLogs from '../Tabs/UserEmailLogs'
import UserNotifications from '../Tabs/UserNotifications'
import UserBidHistory from '../Tabs/UserBidHistory'
import UserSmsLogs from '../Tabs/UserSmsLogs'
import PrimaryButton from '../../../../../product/components/atoms/PrimaryButton'
import FullScreenPopup from '../../FullScreenPopup'
import AuthContext from '../../../../../product/context/auth/authContext'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { mapData, formatPhone } from '../../../../../product/common/components'
import BaseActionPage from '../../../../../product/components/species/dynamic/common/BaseActionPage'
import UserContext from '../../../../../product/context/user/userContext'
import Loaders from '../../../../../product/components/molecules/Loaders'
import DynamicListing from '../../../../../views/Listing/dynamicListing'
import DynamicContext from '../../../../../product/context/dynamic/dynamicContext'
import moment from 'moment'
import ListingTableView from '../../../../../product/components/organisms/Product/TableView'
import EmployeeContext from '@/product/context/employee/empContext'
import { useTranslation } from 'react-i18next'
import { t } from 'i18next'

function TabPanel(props) {
    const { children, value, index, ...other } = props
    const { t } = useTranslation()

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    <>{children}</>
                </div>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const SellerFields = (props) => {
    const userContext = useContext(UserContext)
    const authContext = useContext(AuthContext)
    const dynamicContext = useContext(DynamicContext)
    const employeeContext = useContext(EmployeeContext)
    const { t } = useTranslation()
    const [reload, setReload] = useState(false)

    const {
        single_user,
        getSingleUser,
        userAction,
        responseStatus: responseStatusUser,
    } = userContext
    const {
        user,
        loadUser,
        updateProfile,
        responseStatus: responseStatus,
    } = authContext
    const { auction_tablefields, project_tablefields } = dynamicContext

    const {
        single_employee,
        getSingleEmployee,
        employeeAction,
        changeUserStatus,
        responseStatus: responseStatusEmployee,
    } = employeeContext

    const data = props.data
    const toggleFullScreenPopup = props.function
    const [isLoading, setIsLoading] = useState(false)
    const [buttonData, setButtonData] = useState([])
    const [searchInfo, setSearchInfo] = useState({})
    const [action, setAction] = useState('')

    const [mapDataValue, setMapDataValue] = useState([])

    const [formikValues, setFormikValues] = useState({})
    const [tableValue, setTableValue] = useState([])

    const mapDataValueRef = useRef(mapDataValue)
    useEffect(() => {
        mapDataValueRef.current = mapDataValue
    })

    const handleMapDataValue = (childMapDataValue) => {
        setMapDataValue(childMapDataValue)
    }

    const [customValidation, setCustomValidation] = useState([])
    const [customInitialValues, setCustomInitialValues] = useState([])
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
    })
    const [value, setValue] = useState(0)

    const toggleEditPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    useEffect(() => {
        let customValidationTemp = {}
        let customInitialVal = props.customInitial

        customValidationTemp = {
            email: Yup.string()
                .email('Invalid email format')
                .max(250, 'Maximum 250 characters')
                .required('Required'),
            confirm_email:
                data.status === 'new'
                    ? Yup.string()
                          .email('Invalid email format')
                          .oneOf([Yup.ref('email')], "Email's not match")
                          .required('Required!')
                    : Yup.string(),
            phone: Yup.string()
                .trim()
                .matches(/^[0-9- +()]*$/g, 'Only Numbers Are Allowed')
                .required('Required'),
            zip: Yup.string()
                .trim()
                .matches(/^[0-9]*$/g, 'Only numbers are allowed')
                .max(6, 'Maximum 6 characters')
                .min(5, 'Minimum 5 characters')
                .required('Required'),
            ...props.customValidation,
        }
        setCustomInitialValues(customInitialVal)
        setCustomValidation(customValidationTemp)
    }, [props.fieldValue, props.customValidation, props.customInitial])

    const additionalFormikUpdate = (data) => {
        if (props.additionalFormikUpdate) {
            props.additionalFormikUpdate(data)
        }
        setFormikValues(data)
    }

    const submitFunction = (values) => {
        const value = formikValues
        if (
            values?.encryptedValues &&
            Object.keys(values?.encryptedValues).length
        ) {
            Object.keys(values?.encryptedValues).map((item) => {
                if (item && values?.encryptedValues[item]) {
                    value[item] = values?.encryptedValues[item]
                }
            })
        }
        setIsLoading(true)
        if (value.both_access) {
            value.is_requested = 0
        }
        if (props.formatPhone && props?.phoneField?.length) {
            props?.phoneField.map((data) => {
                if (value[data]) {
                    value[data] = formatPhone(value[data])
                }
            })
        }
        if (value?.license_expiry_date && value?.license_expiry_date !== '') {
            value.license_expiry_date = moment(
                value.license_expiry_date
            ).format('YYYY-MM-DD')
        }
        if (props?.sellerAdmin) {
            value.emp_permissions = value?.id
                ? undefined
                : props?.sellerAdminPermissions
            value.admin = 1
            value.modifyEmployee = true
            value.as_employees_id = single_user?.record?.as_employees_id
        }
        userAction(value)
    }
    const formSubmit = (value, data) => {
        setFormikValues({
            ...formikValues,
            market_status: data,
        })
        submitFunction(value)
    }

    const cancelSubmit = () => {
        setIsLoading(false)
        toggleFullScreenPopup(false, '', 0)
    }

    useEffect(() => {
        setIsLoading(true)
        setTimeout(() => {
            setIsLoading(false)
        }, 1000)
        if (data.status !== 'edit') {
            if (data.status === 'new') {
                setFormikValues({
                    ...formikValues,
                    id: 0,
                })
            }
        }
    }, [data.id])

    useEffect(() => {
        if (responseStatusUser && responseStatusUser.from == 'userAction') {
            setIsLoading(false)
        }
    }, [responseStatusUser])

    useEffect(() => {
        const buttonDataTemp = []
        if (formikValues.id && value) {
            if (formikValues.market_status === 'draft') {
                buttonDataTemp.push({
                    type: 'button',
                    style: 'secondary',
                    label: t('SAVE AS DRAFT'),
                    additionalValue: 'draft',
                })
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: t('submit'),
                    additionalValue: 'open',
                })
            }
            if (formikValues.market_status === '') {
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: t('UPDATE'),
                    additionalValue: 'open',
                })
            }
        } else {
            buttonDataTemp.push({
                type: 'submit',
                style: 'primary',
                label: t('submit'),
                additionalValue: 'open',
            })
        }
        setButtonData(buttonDataTemp)
    }, [formikValues.id, formikValues.market_status, value])

    useEffect(() => {
        if (mapDataValueRef.current.length) {
            let tempMapData = mapDataValueRef.current
            tempMapData.map((mapValue) => {
                if (mapValue.name == 'resale_certificate') {
                    mapValue.class = `col-12 ${
                        formikValues.tax_number !== '' ? '' : 'd-none'
                    }`
                }
            })
            setReload(!reload)
            // setMapDataValue(tempMapData)
            // setResetMapData(true)
        }
    }, [formikValues])

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    useEffect(() => {
        setValue(0)
    }, [data.popup])

    const notesValidation = Yup.object({
        reject_notes: Yup.string().required('Required'),
    })

    const notesFormik = useFormik({
        initialValues: {
            id: 0,
            email: '',
            reject_notes: '',
        },
        validationSchema: notesValidation,
        onSubmit: (values) => {
            userAction(values)
        },
    })

    const notesField = {
        formik: notesFormik,
        data: [
            {
                label: 'Notes',
                type: 'textarea',
                placeholder: 'Enter notes',
                class: 'col-12',
                name: 'reject_notes',
            },
        ],
    }

    const validationPassword = Yup.object({
        change_password: Yup.boolean(),
        new_password: Yup.string()
            .notOneOf(
                [Yup.ref('current_password')],
                'New password must be different'
            )
            .min(8, 'Minimum 8 characters')
            .required('Required'),
        confirm_password: Yup.string()
            .oneOf([Yup.ref('new_password')], 'Passwords Not Match')
            .required('Required'),
    })

    const formikPassword = useFormik({
        initialValues: {
            id: 0,
            noCurrentCheck: true,
            change_password: 1,
            current_password: '',
            new_password: '',
            confirm_password: '',
        },
        validationSchema: validationPassword,
        onSubmit: (values) => {
            if (values.id) {
                userAction(values)
                setIsLoading(true)
            }
        },
    })

    const formikEmpPassword = useFormik({
        initialValues: {
            id: 0,
            change_password: true,
            password: '',
            confirm_password: '',
        },
        validationSchema: Yup.object({
            password: Yup.string()
                .min(8, 'Minimum 8 characters')
                .required('Required!'),
            confirm_password: Yup.string()
                .oneOf([Yup.ref('password')], 'Passwords not match')
                .required('Required!'),
        }),
        onSubmit: (values) => {
            values.id = single_user?.record?.as_employees_id
            if (values.id) {
                employeeAction(values)
                setIsLoading(true)
            }
        },
    })

    const passwordEmpChange = [
        {
            label: 'Password',
            placeholder: 'Enter Password',
            type: 'password',
            class: 'col-sm-6 col-12',
            name: 'password',
        },
        {
            label: 'Re-Enter Password',
            placeholder: 'Re-Enter password',
            type: 'password',
            class: 'col-sm-6 col-12',
            name: 'confirm_password',
        },
    ]

    const passwordChange = [
        {
            label: 'Password',
            name: 'new_password',
            type: 'password',
            placeholder: 'Enter your New password',
            class: 'col-md-6 col-sm-12',
        },
        {
            label: 'Confirm password',
            name: 'confirm_password',
            type: 'password',
            placeholder: 'Re enter your password',
            class: 'col-md-6 col-sm-12',
        },
    ]

    useEffect(() => {
        if (
            responseStatusEmployee &&
            props.empPassword &&
            responseStatusEmployee.from == 'employeeAction'
        ) {
            formikEmpPassword.setValues({
                password: '',
                confirm_password: '',
            })
            formikEmpPassword.setTouched({}, false)
            setIsLoading(false)
        }
    }, [responseStatusEmployee])

    useEffect(() => {
        if (single_user) {
            notesFormik.values.reject_notes = single_user.record.reject_notes
            notesFormik.values.id = single_user.record.id
            notesFormik.values.email = single_user.record.email
        }
    }, [single_user])

    const custom = {
        action: {
            value: action
                ? action.toString() !== 'all'
                    ? action.toString()
                    : ''
                : null,
            type: 'in',
            field: 'p.market_status',
        },
        user_id: {
            value: single_user.record.as_employees_id
                ? single_user.record.as_employees_id
                : 0,
            type: 'in',
            field: 'p.user_id',
        },
    }

    useEffect(() => {
        if (project_tablefields && project_tablefields.length) {
            let dynamicValueAssign = [...project_tablefields]
            let searchData = [...dynamicValueAssign]
            let dynamicSearch = {}
            dynamicSearch.data = searchData
                .filter((item) => item.table_search === 1)
                .map((buscat) => {
                    return Object.assign(buscat, {
                        name: buscat.field,
                    })
                })
            if (action === 'draft') {
                dynamicValueAssign.push({
                    active: 1,
                    field: 'requiredFieldsStatus',
                    folder: null,
                    id: 21,
                    is_deletable: 0,
                    label: 'Status',
                    show_order: 500,
                    sort: 0,
                    sort_field: 'p.wprice',
                    table_search: 0,
                    type: 'tooltip',
                    tooltipTitle: 'requiredFields',
                    tooltipType: 'field',
                    view_page: '1',
                })
            }
            setTableValue(dynamicValueAssign)
            setSearchInfo(dynamicSearch)
        }
    }, [project_tablefields, action])

    return props.standalone ? (
        <>
            <div className="addUserModal">
                <div className="fspBody">
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <div className="customerDetailTabs">
                            <AppBar position="static">
                                <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    aria-label="seller tabs"
                                    variant="scrollable"
                                    scrollButtons="auto"
                                >
                                    <Tab
                                        label={t('PROFILE')}
                                        {...a11yProps(0)}
                                    />
                                    <Tab
                                        label={t('Add Listing')}
                                        {...a11yProps(1)}
                                    />
                                    <Tab
                                        label={t('DRAFT')}
                                        {...a11yProps(2)}
                                        onClick={() => setAction('draft')}
                                    />
                                    <Tab
                                        label={t('active')}
                                        {...a11yProps(3)}
                                        onClick={() => setAction('open')}
                                    />
                                    <Tab
                                        label={t('sold')}
                                        {...a11yProps(4)}
                                        onClick={() => setAction('sold')}
                                    />
                                    <Tab
                                        label={t('Invoices')}
                                        {...a11yProps(5)}
                                    />
                                    <Tab
                                        label={t('LOGIN INFO')}
                                        {...a11yProps(6)}
                                    />
                                </Tabs>
                            </AppBar>
                            <TabPanel value={value} index={0}>
                                <BaseActionPage
                                    arrayValue={props.fieldValue}
                                    data={props.data}
                                    additionalFormikUpdate={
                                        additionalFormikUpdate
                                    }
                                    editFunction={getSingleUser}
                                    editValue={single_user}
                                    handleMapDataValue={handleMapDataValue}
                                    actionFunction={formSubmit}
                                    cancelFunction={cancelSubmit}
                                    buttonAction={buttonData}
                                    customValidation={customValidation}
                                    populateValidation={
                                        props.populateValidation
                                    }
                                    changePassword={props.changePassword}
                                    passwordChange={passwordChange}
                                    formikPassword={formikPassword}
                                    passwordEmpChange={passwordEmpChange}
                                    formikEmpPassword={formikEmpPassword}
                                    customInitialValues={customInitialValues}
                                    empPassword={props.empPassword}
                                />
                            </TabPanel>

                            <TabPanel value={value} index={1}>
                                <DynamicListing
                                    standalone={true}
                                    userId={
                                        single_user.record.as_employees_id
                                            ? single_user.record.as_employees_id
                                            : 0
                                    }
                                    sellerId={
                                        single_user.record.id
                                            ? single_user.record.id
                                            : 0
                                    }
                                    closeFunction={toggleFullScreenPopup}
                                    seller={global.seller ? true : false}
                                />
                            </TabPanel>

                            <TabPanel value={value} index={2}>
                                <ListingTableView
                                    customFilter={custom}
                                    searchInfo={searchInfo}
                                    permission={true}
                                    tableValue={tableValue}
                                    tableActionString={[
                                        'open',
                                        'auction_assign',
                                    ]}
                                    listActionString={['bidcount']}
                                    action="draft"
                                    reorderId="draftLots"
                                    toggleFullScreenPopup={toggleEditPopup}
                                />
                            </TabPanel>

                            <TabPanel value={value} index={3}>
                                <ListingTableView
                                    customFilter={custom}
                                    searchInfo={searchInfo}
                                    tableValue={tableValue}
                                    permission={true}
                                    tableActionString={[
                                        'open',
                                        'auction_assign',
                                    ]}
                                    listActionString={['bidcount']}
                                    action="open"
                                    reorderId="openLots"
                                    toggleFullScreenPopup={toggleEditPopup}
                                />
                            </TabPanel>

                            <TabPanel value={value} index={4}>
                                <ListingTableView
                                    customFilter={custom}
                                    tableValue={tableValue}
                                    searchInfo={searchInfo}
                                    permission={true}
                                    tableActionString={[
                                        'open',
                                        'auction_assign',
                                    ]}
                                    listActionString={['bidcount']}
                                    action="sold"
                                    reorderId="soldLots"
                                />
                            </TabPanel>

                            <TabPanel value={value} index={5}>
                                <UserInvoices
                                    userId={
                                        single_user?.record?.as_employees_id
                                    }
                                    standalone={props.standalone}
                                    seller={true}
                                />
                            </TabPanel>

                            <TabPanel value={value} index={6}>
                                <LoginInfo data={single_user?.record} />
                            </TabPanel>
                        </div>
                    )}
                </div>
            </div>
            {/* <div className="dynamic-listing-wrapper">
                <DynamicListing
                    data={manage}
                    function={toggleEditPopup}
                    permission={true}
                />
            </div> */}
        </>
    ) : (
        <>
            <FullScreenPopup
                modaltitle={
                    data.status === 'new' ? t('ADD NEW USER') : t('EDIT USER')
                }
                open={
                    data.status === 'edit' || data.status === 'new'
                        ? data.popup
                        : false
                }
                handleClose={() => {
                    setIsLoading(false), toggleFullScreenPopup(false, '', 0)
                }}
            >
                <div className="addUserModal">
                    <div className="fspBody">
                        {isLoading ? (
                            <div className="fspLoader">
                                <Loaders isLoading={isLoading} />
                            </div>
                        ) : (
                            <div className="customerDetailTabs">
                                <AppBar position="static">
                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        aria-label="seller tabs"
                                        variant="scrollable"
                                        scrollButtons="auto"
                                    >
                                        <Tab
                                            label={t('PROFILE')}
                                            {...a11yProps(0)}
                                        />
                                        <Tab
                                            label={t('Add Listing')}
                                            {...a11yProps(1)}
                                        />
                                        <Tab
                                            label={t('DRAFT')}
                                            {...a11yProps(2)}
                                            onClick={() => setAction('draft')}
                                        />
                                        <Tab
                                            label={t('active')}
                                            {...a11yProps(3)}
                                            onClick={() => setAction('open')}
                                        />
                                        <Tab
                                            label={t('sold')}
                                            {...a11yProps(4)}
                                            onClick={() => setAction('sold')}
                                        />
                                        <Tab
                                            label={t('Invoices')}
                                            {...a11yProps(5)}
                                        />
                                        <Tab
                                            label={t('LOGIN INFO')}
                                            {...a11yProps(6)}
                                        />
                                    </Tabs>
                                </AppBar>
                                <TabPanel value={value} index={0}>
                                    <BaseActionPage
                                        arrayValue={props.fieldValue}
                                        data={props.data}
                                        additionalFormikUpdate={
                                            additionalFormikUpdate
                                        }
                                        editFunction={getSingleUser}
                                        editValue={single_user}
                                        handleMapDataValue={handleMapDataValue}
                                        actionFunction={formSubmit}
                                        cancelFunction={cancelSubmit}
                                        buttonAction={buttonData}
                                        customValidation={customValidation}
                                        changePassword={props.changePassword}
                                        passwordChange={passwordChange}
                                        formikPassword={formikPassword}
                                        passwordEmpChange={passwordEmpChange}
                                        formikEmpPassword={formikEmpPassword}
                                        customInitialValues={
                                            customInitialValues
                                        }
                                        empPassword={props.empPassword}
                                        formatCustomDate={
                                            props.formatCustomDate
                                        }
                                    />
                                </TabPanel>

                                <TabPanel value={value} index={1}>
                                    <DynamicListing
                                        standalone={true}
                                        userId={
                                            single_user.record.as_employees_id
                                                ? single_user.record
                                                      .as_employees_id
                                                : 0
                                        }
                                        closeFunction={toggleFullScreenPopup}
                                    />
                                </TabPanel>

                                <TabPanel value={value} index={2}>
                                    <ListingTableView
                                        customFilter={custom}
                                        searchInfo={searchInfo}
                                        permission={true}
                                        tableValue={tableValue}
                                        tableActionString={[
                                            'open',
                                            'auction_assign',
                                        ]}
                                        listActionString={['bidcount']}
                                        action="draft"
                                        reorderId="draftLots"
                                        toggleFullScreenPopup={toggleEditPopup}
                                    />
                                </TabPanel>

                                <TabPanel value={value} index={3}>
                                    <ListingTableView
                                        customFilter={custom}
                                        searchInfo={searchInfo}
                                        tableValue={tableValue}
                                        permission={true}
                                        tableActionString={[
                                            'open',
                                            'auction_assign',
                                        ]}
                                        listActionString={['bidcount']}
                                        action="open"
                                        reorderId="openLots"
                                        toggleFullScreenPopup={toggleEditPopup}
                                    />
                                </TabPanel>

                                <TabPanel value={value} index={4}>
                                    <ListingTableView
                                        customFilter={custom}
                                        tableValue={tableValue}
                                        searchInfo={searchInfo}
                                        permission={true}
                                        tableActionString={[
                                            'open',
                                            'auction_assign',
                                        ]}
                                        listActionString={['bidcount']}
                                        action="sold"
                                        reorderId="soldLots"
                                    />
                                </TabPanel>

                                <TabPanel value={value} index={5}>
                                    <UserInvoices
                                        userId={single_user?.record?.user_id}
                                    />
                                </TabPanel>

                                <TabPanel value={value} index={6}>
                                    <LoginInfo data={single_user?.record} />
                                </TabPanel>
                            </div>
                        )}
                    </div>
                </div>
            </FullScreenPopup>
            <DynamicListing
                data={manage}
                function={toggleEditPopup}
                permission={true}
            />
        </>
    )
}

export default SellerFields
